import React, { useEffect, useState } from "react";
import { LatestRecipient, walletRepository } from "../../../../repositories/WalletRepository";
import { OPAAvatar } from "../../../../components/OPAAvatar";
import { Pleb } from "../../../../models/Pleb";

interface LatestRecipientsProps {
    onSelectPleb: (pleb: Pleb) => void;
    onSelectLnurl: (lnurl: string) => void;
    className?: string;
}

export const LatestRecipients: React.FC<LatestRecipientsProps> = ({ onSelectPleb, onSelectLnurl, className }) => {
    const [latestRecipients, setLatestRecipients] = useState<LatestRecipient[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        walletRepository.getLatestRecipients()
            .then((recipients: LatestRecipient[]) => {
                setLatestRecipients(recipients);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if(loading)
        return (
            <div className={className}>
                <div className="text-lg font-semibold mb-1 mt-4 text-brand-orange">Recent addresses</div>
                <div className="h-[168px]"></div>
            </div>
        )

    if(latestRecipients.length === 0)
        return null;

    return (
        <div className={className}>
            <div className="text-lg font-semibold mb-1 mt-4 text-brand-orange">Recent addresses</div>
            {latestRecipients.map((recipient, index) => {
                let className = index === latestRecipients.length - 1 ? "" : "border-b border-brand-border-color";
                
                if(recipient.internalUser)
                {
                    return (
                        <div key={index} className={`${className}`}>
                            <div
                                
                                onClick={() => onSelectPleb(recipient.internalUser)}
                                className="flex items-center gap-2 py-2 mx-[-10px] px-[10px] cursor-pointer hover:bg-brand-bg-4 rounded-lg"
                            >
                                <OPAAvatar
                                    imageUrl={recipient.internalUser?.thumbnail}
                                    size={40}
                                    borderWidth={0}
                                    borderColor="var(--brand-bg-2)"
                                />
                                {recipient.internalUser?.name}
                            </div>
                        </div>
                    );
                }
                else if(recipient.lnurl)
                {
                    return (
                        <div key={index} className={`${className}`}>
                            <div
                                onClick={() => onSelectLnurl(recipient.lnurl)}
                                className="flex items-center gap-2 py-2 mx-[-10px] px-[10px] cursor-pointer hover:bg-brand-bg-4 rounded-lg"
                            >
                                {recipient.lnurl}
                            </div>
                        </div>
                    );
                }
                else return null;
            })}
        </div>
    );
}